/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__Question_4Inputs */

const en_help_center__account_n_technical__question_4 = /** @type {(inputs: Help_Center__Account_N_Technical__Question_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I can't place bids during a live battle. Help!`)
};

/**
* | output |
* | --- |
* | "I can't place bids during a live battle. Help!" |
*
* @param {Help_Center__Account_N_Technical__Question_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__question_4 = /** @type {((inputs?: Help_Center__Account_N_Technical__Question_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__Question_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__question_4(inputs)
});